import { Component, Input } from '@angular/core';
import { SteelCartItem } from '@lobos/library';

@Component({
  selector: 'app-cart-detail-item-text-optional',
  templateUrl: './cart-detail-item-text-optional.component.html',
  styleUrls: ['./cart-detail-item-text-optional.component.scss'],
})
export class CartDetailItemTextOptionalComponent {
  @Input() item!: SteelCartItem;
}
